export default "__VITE_ASSET__50cd3ca9__"